window.__FOUNDATION_MOBILE__ = true

require('./Foundation/Mobile/libs/iScroll.js')
require('./Foundation/Mobile/libs/animation.js')
require('./Foundation/Mobile/libs/autosize.js')
require('./Foundation/Mobile/libs/matchMedia.js')
require('./Foundation/Mobile/libs/modernizer.js')
require('!script-loader!./Foundation/Mobile/libs/owl.js')
require('!script-loader!./Foundation/Mobile/libs/photoswipe.js')
require('./Foundation/Mobile/libs/semantic.js')

require('./foundation.js')
require('./foundation-mobile.js')
